import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, MenuItem } from '@mui/material';

import { BLACK } from '../../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../../theme/fontConstants';
import { canSetApprovalStatus, FORM_STATUS_OPTIONS } from '../documentReview';

const formStatusMenuItemSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 1.5,
  minWidth: '180px',
  fontFamily: PRIMARY_FONT[400],
  fontSize: '14px',
  color: BLACK[100],
  py: 1,
  px: 1.5,
};

const FormStatusMenuItems = ({ document, onSelect }) =>
  FORM_STATUS_OPTIONS.map((option) => {
    const isEnabled = canSetApprovalStatus(document, option.status);

    return (
      <MenuItem
        key={option.status}
        disabled={!isEnabled}
        onClick={isEnabled ? () => onSelect(option.status) : undefined}
        sx={formStatusMenuItemSx}
      >
        <Box
          component="span"
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: option.dotColor,
            flexShrink: 0,
          }}
        />
        {LanguageConverterV2(option.labelKey)}
      </MenuItem>
    );
  });

FormStatusMenuItems.propTypes = {
  document: PropTypes.shape({
    _id: PropTypes.string,
    state: PropTypes.shape({ status: PropTypes.string }),
    validity: PropTypes.shape({ status: PropTypes.string }),
  }).isRequired,
  onSelect: PropTypes.func,
};

FormStatusMenuItems.defaultProps = {
  onSelect: () => {},
};

export default FormStatusMenuItems;
